import React, { FunctionComponent, SVGProps } from 'react';

import styled from 'styled-components';

export interface AttachmentIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const AttachmentIcon: FunctionComponent<AttachmentIconProps> = ({
  className,
  ...props
}) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    className={className || ''}
    {...props}
  >
    <Path d="M13.73,8.03c-.35-.34-.9-.34-1.23,0l-4.18,4.12c-1.5,1.48-3.95,1.48-5.44,0-1.49-1.47-1.5-3.87,0-5.38L7.35,2.37c.89-.88,2.33-.88,3.21,0,.42,.42,.66,.98,.66,1.58s-.23,1.16-.63,1.57l-4.5,4.44c-.27,.27-.71,.27-1,0-.27-.27-.27-.7,0-.97l4.18-4.13c.35-.33,.35-.89,0-1.22-.16-.16-.39-.26-.62-.26s-.45,.09-.62,.26L3.86,7.76c-.95,.94-.96,2.48,0,3.43,.95,.94,2.51,.94,3.46,0l4.47-4.41c.76-.75,1.18-1.75,1.18-2.81s-.42-2.06-1.18-2.81C10.23-.39,7.67-.39,6.1,1.16L1.64,5.55c-1.06,1.05-1.64,2.45-1.64,3.92s.58,2.86,1.64,3.92c1.09,1.08,2.52,1.62,3.96,1.62s2.87-.54,3.96-1.62l4.18-4.12c.34-.34,.35-.89,0-1.22h-.01Z" />
  </svg>
);

export default AttachmentIcon;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.primary};
`;
